import React from 'react';
import styled from 'styled-components';
import { useFilterContext } from '../context/filter_context';
import { getUniqueValues, formatPrice } from '../utils/helpers';
import { FaCheck } from 'react-icons/fa';

const Filters = () => {
  let { filters, updateFilters, products, minPrice, maxPrice, clearFilters } =
    useFilterContext();
  let { text, category, company, color, price, shipping } = filters;

  let categories = getUniqueValues(products, 'category');
  let companies = getUniqueValues(products, 'company');
  let colors = getUniqueValues(products, 'colors');

  return (
    <Wrapper>
      <div className="content">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="form-control">
            <input
              type="text"
              name="text"
              placeholder="search"
              className="search-input"
              value={text}
              onChange={(e) => updateFilters(e.target.name, e.target.value)}
            />
          </div>
          <div className="form-control">
            <h5>category</h5>
            <div>
              {categories.map((c, index) => (
                <button
                  key={index}
                  type="button"
                  name="category"
                  className={c === category && 'active'}
                  onClick={(e) =>
                    updateFilters(e.target.name, e.target.textContent)
                  }
                >
                  {c}
                </button>
              ))}
            </div>
          </div>
          <div className="form-control">
            <h5>company</h5>
            <select
              name="company"
              className="company"
              value={company}
              onChange={(e) => updateFilters(e.target.name, e.target.value)}
            >
              {companies.map((company) => (
                <option value={company}>{company}</option>
              ))}
            </select>
          </div>
          <div className="form-control">
            <h5>colors</h5>
            <div className="colors">
              <button
                name="color"
                data-color="all"
                className={`all-btn ${color === 'all' && 'active'}`}
                onClick={(e) =>
                  updateFilters(e.target.name, e.target.dataset.color)
                }
              >
                all
              </button>
              {colors.map((c) => (
                <button
                  name="color"
                  className={`color-btn ${c === color && 'active'}`}
                  data-color={c}
                  style={{ background: c }}
                  onClick={(e) =>
                    updateFilters(e.target.name, e.target.dataset.color)
                  }
                >
                  {c === color && <FaCheck />}
                </button>
              ))}
            </div>
          </div>
          <div className="form-control">
            <h5>price</h5>
            <p className="price">{formatPrice(price)}</p>
            <input
              type="range"
              name="price"
              min={minPrice}
              max={maxPrice}
              value={price}
              onChange={(e) =>
                updateFilters(e.target.name, Number(e.target.value))
              }
            />
          </div>
          <div className="form-control shipping">
            <label for="shipping">free shipping</label>
            <input
              type="checkbox"
              name="shipping"
              id="shipping"
              checked={shipping}
              onClick={(e) => updateFilters(e.target.name, e.target.checked)}
            />
          </div>
        </form>
        <button type="button" className="clear-btn" onClick={clearFilters}>
          clear filters
        </button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .form-control {
    margin-bottom: 1.25rem;
    h5 {
      margin-bottom: 0.5rem;
    }
  }
  .search-input {
    padding: 0.5rem;
    background: var(--clr-grey-10);
    border-radius: var(--radius);
    border-color: transparent;
    letter-spacing: var(--spacing);
  }
  .search-input::placeholder {
    text-transform: capitalize;
  }

  button {
    display: block;
    margin: 0.25em 0;
    padding: 0.25rem 0;
    text-transform: capitalize;
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    letter-spacing: var(--spacing);
    color: var(--clr-grey-5);
    cursor: pointer;
    transition:border-color 0.3s
  }
  .active {
    border-color: var(--clr-grey-5);
  }
  .company {
    background: var(--clr-grey-10);
    border-radius: var(--radius);
    border-color: transparent;
    padding: 0.25rem;
  }
  .colors {
    display: flex;
    align-items: center;
  }
  .color-btn {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: #222;
    margin-right: 0.5rem;
    border: none;
    cursor: pointer;
    opacity: 0.5;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.25s;
    svg {
      font-size: 0.5rem;
      color: var(--clr-white);
    }
    &:hover{
      opacity: 1;
    }
  }
  .all-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.5rem;
    opacity: 0.5;
  }
  .active {
    opacity: 1;
  }
  .all-btn .active {
    text-decoration: underline;
  }
  .price {
    margin-bottom: 0.25rem;
  }
  .shipping {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    text-transform: capitalize;
    column-gap: 0.5rem;
    font-size: 1rem;
    max-width: 200px;
  }
  .clear-btn {
    background: var(--clr-red-dark);
    color: var(--clr-white);
    padding: 0.25rem 0.5rem;
    border-radius: var(--radius);
  }
  @media (min-width: 768px) {
    .content {
      position: sticky;
      top: 1rem;
    }
  }
`;

export default Filters;
